/* eslint-disable */
// import 'promise-polyfill/src/polyfill'
// import 'babel-polyfill'
import './assets/getcomputedstylepfill'
import './assets/btoappfill'
import Vue from 'vue'
import App from './App'
import Vuex from 'vuex'
import {store as storeConfig} from './store'
import vuescroll from 'vue-scroll'
import VueCookie from 'vue-cookie'

if (!global._babelPolyfill) {
  try {
    require('babel-polyfill')
  } catch (e) {}
} else {
  global._babelPolyfill = false
}

Vue.use(vuescroll)
Vue.use(Vuex)
Vue.use(VueCookie)

Vue.config.productionTip = false
const store = new Vuex.Store(storeConfig)
store.dispatch('init')
store.dispatch('load')
  .then(() => {
    /* eslint-disable no-new */
    console.log('--- v 1.0.1 ieMode')
    window.mmprvapp = new Vue({
      el: '#mm-prv-read-wdg',
      components: { App },
      template: '<App/>',
      store
    })

  })
  .catch((e) => console.log(e))



// WEBPACK FOOTER //
// ./src/main.js